import { styled } from "@mui/material/styles";
import { Box, TableCell, TableCellProps, TableRow } from "@mui/material";

type StyledTableCellProps = {
  columnWidth?: string;
  disabled?: boolean;
};

type ButtonTableCellProps = {
  disabled?: boolean;
};

interface StyledTableHeadingCellProps extends TableCellProps {
  textAlign?: "left" | "center" | "right" | "justify" | "inherit";
}

export const StyledTableRow = styled(TableRow)(() => ({
  border: "none",
}));

export const StyledTableHeadingCell = styled(TableCell, {
  shouldForwardProp: (prop) => prop !== "textAlign",
})<StyledTableHeadingCellProps>(({ textAlign = "left" }) => ({
  border: "none",
  fontSize: "12px",
  lineHeight: "normal",
  paddingLeft: "5px",
  paddingRight: "10px",
  paddingBottom: "10px",
  overflowWrap: "anywhere",
  verticalAlign: "top",
  textAlign,
}));

// Note: refactor to use StyledTableCell2 instead
export const StyledTableCell = styled(TableCell, {
  shouldForwardProp: (prop) => prop !== "columnWidth" && prop !== "disabled",
})<StyledTableCellProps>(({ columnWidth, disabled }) => ({
  border: "none",
  width: columnWidth || "unset",
  padding: 0,
  paddingBottom: "12px",
  paddingRight: "5px",
  backgroundColor: disabled ? "#fff" : "inherit",
  "& > p": {
    fontWeight: "inherit",
  },
}));

export const StyledTableCell2 = styled(TableCell, {
  shouldForwardProp: (prop) => prop !== "columnWidth",
})<StyledTableCellProps>(({ columnWidth }) => ({
  width: columnWidth || "unset",
  borderBottom: "none",
}));

export const StyledTableMenuCell = styled(TableCell)(() => ({
  border: "none",
  padding: "4px 0px",
}));

export const TableCellContentContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "columnWidth",
})<StyledTableCellProps>(({ columnWidth }) => ({
  width: columnWidth,
  display: "block",
  alignItems: "center",
  position: "relative",
  border: "1px solid #E0E0E0",
  borderRadius: "4px",
  backgroundColor: "#F9F9FA99",
  padding: "8px",
  height: "37px",
  marginRight: "8px",
}));

export const ButtonTableCell = styled(TableCell, {
  shouldForwardProp: (prop) => prop !== "disabled",
})<ButtonTableCellProps>(({ disabled }) => ({
  padding: 0,
  backgroundColor: disabled ? "#fff" : "inherit",
}));
